import { render } from "./SnackBar.vue?vue&type=template&id=50ca85f5&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"

import "./SnackBar.vue?vue&type=style&index=0&id=50ca85f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ca85f5"]])

export default __exports__